<template>
  <div class="full-page">
    <div class="wrapper wrapper-full-page">
      <div class="login-page page-header header-filter" filter-color="black" :style="setBgImage">
        <div class="container md-offset">
          <div class="md-layout text-center">
            <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
              <div class="login-logo-img">
                <img :src="logo1" />
              </div>
              <login-card header-color="grey">
                <h3 slot="title" class="title">Reset Your Password</h3>
                <p slot="description">We Will Send You an email to reset Your Password </p>
                <md-field class="md-form-group login-field" slot="inputs">
                  <md-icon class="login-icon">email</md-icon>
                  <label>Email...</label>
                  <md-input v-model="email" type="email" @keyup.enter="forgotPassword"></md-input>
                </md-field>

                <v-progress-circular v-if="loading" indeterminate class="loginLoader"
                  slot="loader"></v-progress-circular>

                <md-button v-on:click="forgotPassword" slot="footer" class="login-button">
                  <h4>Email Me</h4>
                </md-button>

                <v-alert v-if="error" class="errorMsg" slot="response">{{
                  errorMessage
                }}</v-alert>

                <v-alert v-if="this.isSafari()" class="attentionMsgHighlight" slot="response">
                  Attention: It looks like you’re using Safari - Zink is not currently compatible with Safari and not
                  all
                  features will operate correctly. Please use an alternative browser (I.e. Chrome, Edge, etc)
                </v-alert>
              </login-card>
            </div>
          </div>
        </div>
        <footer class="footer login-page">
          <div class="container md-offset">
            <div class="login-footer-img">
              <img :src="logo2" />
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";

export default {
  components: {
    LoginCard,
  },
  props: {
    logo1: {
      type: String,
      default: require("@/assets/img/zink-automated-finance-software.png")
    },
    backgroundColor: {
      type: String,
      default: "black"
    },
    logo2: {
      type: String,
      default: require("@/assets/img/zink-powered-by-ausloans.png")
    },
  },

  data() {
    return {
      loading: false,
      email: "",
      password: "",
      error: false,
      errorMessage: null,
    };
  },
  computed: {
    setBgImage() {
      let images = {
        ForgotPassword: require("@/assets/img/login-bg.jpg"),
      };
      return {
        backgroundImage: `url(${images[this.$route.name]})`
      };
    },
  },
  methods: {
    async forgotPassword() {
      let status = await this.$store.dispatch('forgotPassword', { email: this.email });
      if (status === true) {
          let data = {
            errorMessage: "Email sent successfully."
          };
          this.$router.push({
            name: "Login", 
            params: { data }
          });
      } else {
        this.error = true;
        this.errorMessage = status;
      }
      this.loading = false;
    },
    isSafari() {
      let userAgent = navigator.userAgent
      let vendor = navigator.vendor
      if (/Safari/i.test(userAgent) && /Apple Computer/.test(vendor)) {
        return true;
      }
      return false;
    },

  },

};
</script>

<style lang="scss">
@import '../assets/scss/theme.scss';
@import '../assets/scss/md-custom/_ausloans-colors.scss';

.errorMsg {
  background-color: red;
  color: white;
}

.loginLoader {
  color: $ausloans-green;
}

.login-logo-img {
  max-width: 340px;
  padding-bottom: 3rem;
  margin: 0 auto;
}

.login-button {
  background-color: $ausloans-green !important;
  color: white !important;
  border-radius: 3px;
  width: 100%;
}

.login-button:Hover {
  background-color: $ausloans-green-dark !important;
}

.login-field {
  margin-top: 30px;
}

.login-icon {
  margin-left: 5px !important;
  margin-right: -5px !important;
}

.attentionMsgHighlight {
  background-color: red !important;
  border-color: white !important;
  color: white !important;
}

.forgot-password {
  margin-top: 40px;
  text-align: right;
}

.login-footer-img {
  max-width: 340px;
  padding-bottom: 0.5%;
  margin: 0 auto;
}

.login-page {
  padding-right: 0px !important;
}
</style>
